import { render, staticRenderFns } from "./PhoneWitnessing.vue?vue&type=template&id=35a2f25a&scoped=true"
import script from "./PhoneWitnessing.vue?vue&type=script&lang=js"
export * from "./PhoneWitnessing.vue?vue&type=script&lang=js"
import style0 from "./PhoneWitnessing.vue?vue&type=style&index=0&id=35a2f25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a2f25a",
  null
  
)

export default component.exports